import { render, staticRenderFns } from "./PageBroadcastDynamic.vue?vue&type=template&id=7163f301&"
import script from "./PageBroadcastDynamic.vue?vue&type=script&lang=js&"
export * from "./PageBroadcastDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports